
/**
 * Custom component for WV Steak House food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <WvSteakHouseFoodItem> copied to <WvSteakHouseCocktailItem>.
 *
 *    2024-07-19 (1.0.1) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <wv-steak-house-cocktail-item>.
 *
 *    2025-04-08 (1.0.2) (jhoward)
 *      - Remove "visual_" prefix from class names in <WVSteakHouseCocktailItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'WVSteakHouseCocktailItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
})
